import { Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitch = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language === 'zh-TW' ? 'en-US' : 'zh-TW';
    i18n.changeLanguage(nextLang);
  };

  return (
    <Button 
      type="text" 
      icon={<GlobalOutlined />}
      onClick={toggleLanguage}
      className="lang-switch"
    >
      {i18n.language === 'zh-TW' ? 'EN' : '中文'}
    </Button>
  );
};

export default LanguageSwitch;